import { render, staticRenderFns } from "./CardEvent.vue?vue&type=template&id=50551b92&scoped=true"
import script from "./CardEvent.vue?vue&type=script&lang=js"
export * from "./CardEvent.vue?vue&type=script&lang=js"
import style0 from "./CardEvent.vue?vue&type=style&index=0&id=50551b92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50551b92",
  null
  
)

export default component.exports